<template>
  <div :class="dynamicClasses" :style="{background: background}">
   <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nna-container',
  props: {
    fluid: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    narrow: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: null
    },
    spacing: {
      type: Number,
      default: 20
    },    
    noPadding: {
      type: Boolean,
      default: false
    },
    curved: {
      type: Boolean,
      default: false
    },
    variant: {
      type: Boolean,
      default: false
    },
    bottomBarActive: {
      type: Boolean,
      default: false
    },
    heightAuto: {
      type: Boolean,
      default: false
    }    
  },
  computed: {
    dynamicClasses () {
      return {
        'container': !this.fluid,
        'container-full': this.full,
        'container-narrow': this.narrow && !this.fluid,
        'container-mobile': this.mobile,
        'container-height-auto': this.heightAuto,
        'container-fluid': this.fluid && !this.narrow,
        'container-inverse': this.inverse,
        'container-padded': !this.noPadding,
        'container-no-padding': this.noPadding,
        'container-curved': this.curved,
        'container-fixed': this.fixed,
        'container-variant': this.variant,
        'container-bottom-bar-acrive': this.bottomBarActive,
        ['container-spacing-'+this.spacing]: this.spacing,
      }
    }
  }
}
</script>
<style scoped>
.container {
  flex: 1 1 auto;
  position: relative; 
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  flex-grow: 1;
  z-index: auto;
  padding: 15px 25px;
  height: calc( 100vh - 56px );
}
.container-height-auto {
  height: auto;
}
.no-scroll .container {
  overflow: hidden;
}

.container-spacing-5 {
  padding: 10px 5px
}
.container-spacing-10 {
  padding: 10px 10px
}
.container-spacing-15 {
  padding: 10px 15px
}
.container-spacing-20 {
  padding: 10px 20px
}
.container-spacing-25 {
  padding: 10px 25px
}
.container-spacing-30 {
  padding: 10px 30px
}
.container-spacing-40 {
  padding: 10px 40px
}

.container-no-padding {
  padding: 0px;
}
.container-bottom-bar-acrive {
  padding-bottom: 56px;
}
</style>




// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/Container/Container.vue